import CorvuDialog from '@corvu/dialog'
import { Button, DialogShell } from '@forest/shared/solid'
import couponImg from '~/assets/images/win-back-coupon.png'
import { m } from '~/paraglide/messages'

/**
 * The win-back dialog (GLOSSARY.md): the X on the plan picker while it shows
 * the promotional annual plan opens it instead of closing the page.
 */
export function WinBackDialog(props: {
  open: boolean
  /** "Back to Offer": close the prompt and stay on the plan picker. */
  onBack: () => void
  /** "Give Up This Only Chance": close the page. */
  onGiveUp: () => void
}) {
  return (
    <DialogShell
      open={props.open}
      onOpenChange={(open) => {
        if (!open) props.onBack()
      }}
      class="flex w-[calc(100vw-48px)] max-w-[300px] flex-col gap-6 p-6 ease-out data-[open]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[open]:fade-in-0 data-[closed]:zoom-out-95 data-[open]:zoom-in-95"
      overlayClass="ease-out data-[open]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[open]:fade-in-0"
    >
      <div class="flex flex-col gap-4">
        <img
          src={couponImg}
          alt=""
          width={252}
          height={172}
          class="h-auto w-full"
        />
        <CorvuDialog.Label class="text-center text-lg font-semibold leading-[26px] text-[#333]">
          {m.dialog_subscription_promotion_trial_extend_title()}
        </CorvuDialog.Label>
      </div>
      <div class="flex flex-col gap-2">
        <Button
          type="button"
          class="text-base leading-5 shadow-[0_0_20px_-2px_rgba(198,255,205,0.15)]"
          onClick={() => props.onBack()}
        >
          {m.back_offer_page()}
        </Button>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          class="w-full"
          onClick={() => props.onGiveUp()}
        >
          {m.give_up_this_chance()}
        </Button>
      </div>
    </DialogShell>
  )
}
